document.addEventListener('DOMContentLoaded', function () {
  // Support legacy id "description-column" and new unique ids starting with "description-column-"
  const nodes = document.querySelectorAll('#description-column, [id^="description-column-"]');

  nodes.forEach((el) => {
    // Keep each heading and its following content in one column, including legacy bold headings.
    let section;
    Array.from(el.childNodes).forEach((node) => {
      const isHeading = node.nodeType === Node.ELEMENT_NODE && (
        node.matches('h1, h2, h3, h4, h5, h6') ||
        (node.matches('p') && node.children.length === 1 &&
          node.firstElementChild.matches('b, strong') &&
          node.textContent.trim() !== '' &&
          node.textContent.trim() === node.firstElementChild.textContent.trim())
      );

      if (isHeading) {
        section = document.createElement('div');
        section.className = 'product-description__section';
        el.insertBefore(section, node);
      }
      if (section) section.appendChild(node);
    });

    const textLength = (el.textContent || '').trim().length;
    try {
      if (textLength < 898) {
        el.classList.remove('dynamic-columns');
        el.classList.add('single-column');
      } else {
        el.classList.add('dynamic-columns');
        el.classList.remove('single-column');
      }
    } catch (e) { /* noop */ }
  });
});
